import React from 'react'
import { Container } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

function Footer() {
  const { pathname } = useLocation()
  const isHome = pathname === '/'

  return (
    <footer className='fc-footer'>
      <Container>
        <div>
          {isHome
            ? <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ background: 'none', border: 'none', padding: 0, color: 'rgba(255,255,255,.5)', fontSize: '.83rem', cursor: 'pointer' }}>Home</button>
            : <Link to='/' style={{ color: 'rgba(255,255,255,.5)', fontSize: '.83rem' }}>Home</Link>
          }
        </div>
        <div className='footer-divider'></div>
        <div>&copy; {new Date().getFullYear()} Francesco Alessandro Cuzzola. All rights reserved.</div>
      </Container>
    </footer>
  )
}

export default Footer
